module.exports = __webpack_public_path__ + "media/src/images/icon_xls-8b2c6dc2c6459c8be5b0d9a730aef554.png";